import React, {useEffect, useState} from "react";
import {useLanguage} from "../hooks/LanguageContext";
import {ContractImg} from "../assets/images";
import apiService from "../services/apiService";

const ShippingAgreementPage = () => {
    const { direction } = useLanguage();
    const [data,setData] = useState(null);

    useEffect(() => {
        apiService
            .getShipmentAgreement()
            .then((response) => {
                setData(response.data);
            })
            .catch((err) => {

            });
    }, []);

    return (
        <div className={`w-full min-h-screen ${direction === "rtl" ? "text-right" : "text-left"} `}>
            {/* Hero Image */}
            <div className="w-full">
                <img
                    src={ContractImg}
                    alt="Shipping agreement"
                    className="w-full h-[280px] object-cover"
                />
            </div>

            {/* Content Section */}
            <div className="container mx-auto px-4 md:px-8 lg:px-16 py-8">
                <h1 className="text-primary-700 text-center text-3xl font-bold mb-6">
                    بنود إتفاقية الشحن
                </h1>

                <div className="space-y-6 text-lg leading-relaxed"
                     dangerouslySetInnerHTML={{
                         __html: data ? (direction === 'rtl' ? data['shipment_agreement_ar'] : data['shipment_agreement_en']) : ''
                     }}
                />
            </div>
        </div>
    );
};

export default ShippingAgreementPage;
